import React from 'react'
import { PlotAndNumbersContainer } from './styles/BuildScenarioPlotContainer.styles'
import UniversalLoader from '../../../ui_reusable/UniversalLoader'
import useBuildScenarioStore from '../stores/buildScenarioStore'
import BuildScenarioPlot from './build_scenario_plot_container/BuildScenarioPlot'
import BuildScenarioNumbers from './build_scenario_plot_container/BuildScenarioNumbers'

const BuildScenarioPlotContainer = ({ selectedModel }) => {
  // Loading state for initial clean model
  const initialCleanModelLoading = useBuildScenarioStore(
    (state) => state.initialCleanModelLoading,
  )

  return (
    <PlotAndNumbersContainer>
      <UniversalLoader
        show={initialCleanModelLoading}
        content="Loading initial model..."
      />
      <BuildScenarioPlot selectedModel={selectedModel} />
      <BuildScenarioNumbers />
    </PlotAndNumbersContainer>
  )
}

export default BuildScenarioPlotContainer
